// Presentation helpers over the unchanged seven-slot weeklyParticipation()
// projection. No calculation lives here: responded/total come straight from
// the shared computation so header chip, Connections row and Updates reader
// always agree for the same project/week/payload.

/** Pure: "{n}/{total} posted" chip model, or an honest unavailable model. */
export function participationChip(st) {
  if (!st || st.status === "loading") return { kind: "loading", text: "…/7 posted", label: "Weekly participation loading" };
  const part = st.status === "ok" ? st.part : null;
  if (!part?.available || part.responded == null) return { kind: "unavailable", text: "Posted n/a", label: "Weekly participation unavailable" };
  const complete = part.responded >= part.total;
  return { kind: complete ? "complete" : "incomplete", text: `${part.responded}/${part.total} posted`,
    label: `${part.responded} of ${part.total} posted this week. Open Updates`, complete };
}

/** Pure: exact "This week: {n} of {total} posted" sentence for a projection. */
export function participationSentence(part) {
  if (!part?.available || part.responded == null) return { available: false, text: "This week: participation unavailable", complete: false };
  return { available: true, text: `This week: ${part.responded} of ${part.total} posted`, complete: part.responded >= part.total };
}

/** Pure: sentence from a drawer participation state ({ status, part }). */
export function participationStateSentence(st) {
  if (!st || st.status === "loading") return { available: false, loading: true, text: "This week: loading participation", complete: false };
  if (st.status === "ok") return participationSentence(st.part);
  return { available: false, text: "This week: participation unavailable", complete: false };
}
